<template>
  <div :class="chartType === 'bar' ? '' : 'mobileChartStyle'">
    <h3 class="topTitle">Progreso por empresa</h3>
    <el-row :class="chartType === 'bar' ? 'roundedBorder' : ''">
      <el-col :span="24" class="relative">
        <div
          v-if="chartType === 'bar'"
          class="textContainer">
          <h3
            class="verticalText"
            :style="chartType === 'bar' ? 'height:150px;' : 'height: 90vh'"></h3>
        </div>
        <div
          :style="chartType === 'bar' ? 'height:150px;' : 'height: 90vh'"
          :class="chartType === 'bar' ? 'chartContainerVertical' : 'chartContainerHorizontal'"
          class="relative">
          <div id="tooltipDisplayInteractive"></div>
          <canvas :id="elementId"></canvas>
        </div>
        <h3
          :class="chartType === 'bar' ? 'horizontalText' : ''"></h3>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
  props: {
    chartType: {
      type: String,
      required: true,
    },
    chartData: {
      type: Array,
      required: true,
    },
    elementId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      firstLoad: false,
      labelAxes: [],
      dataAxes: [],
      propLabels: [],
      propData: [],
      myChart: null,
      max: 100,
    };
  },
  methods: {
    updateChart() {
      this.propLabels = Object.keys(this.chartData[0]);
      this.propData = [];
      if (this.myChart.data != null) {
        this.myChart.data.labels.length = 0;
        this.propLabels.forEach((element, index) => {
          this.myChart.data.labels.push(element);
          this.myChart.data.datasets.forEach((dataset) => {
            const selectedDataset = dataset.data;
            const { delivered } = this.chartData[0][element].progress.delivered;
            const { rejected } = this.chartData[0][element].progress.rejected;
            const progress = delivered + rejected;
            const totalPackages = this.chartData[0][element].progress.total;
            selectedDataset[index] = ((progress / totalPackages) * 100).toFixed(1);
          });
        });
        this.myChart.update();
      }
    },
    init() {
      if (this.chartData.lenght > 0) {
        this.propLabels = Object.keys(this.chartData[0]);
      }
      this.propData = [];
      this.propLabels.forEach((element) => {
        const { delivered } = this.chartData[0][element].progress;
        const { rejected } = this.chartData[0][element].progress;
        const progress = delivered + rejected;
        const totalPackages = this.chartData[0][element].progress.total;
        this.propData.push(((progress / totalPackages) * 100).toFixed(1));
      });
      const thisElement = this;
      const ctx = document.getElementById(this.elementId);
      const colorGreen = [];
      const colorGrey = [];
      this.propData.forEach(() => {
        colorGreen.push('#AAD500');
        colorGrey.push('#e0e0e0');
      });
      let backgroundColors = colorGreen;
      const hoverBackgrounds = colorGreen;
      this.myChart = new Chart(ctx, {
        type: this.chartType,
        data: {
          labels: this.propLabels,
          datasets: [{
            data: this.propData,
            backgroundColor: backgroundColors,
            hoverBackgroundColor: hoverBackgrounds,
          }],
        },
        options: {
          scales: {
            yAxes: [{
              barPercentage: 0.1,
              gridLines: {
                display: true,
              },
              ticks: {
                max: this.max,
                beginAtZero: true,
                min: 0,
                autoSkip: true,
                maxTicksLimit: 3,
                // maxRotation: thisElement.chartType === 'bar' ? 90 : 40,
                // minRotation: thisElement.chartType === 'bar' ? 90 : 40,
                fontSize: 10,
                fontColor: '#808080',
                callback(value) {
                  return thisElement.chartType === 'bar' ? `${((value / this.max) * 100).toFixed(0)}%` : value; // convert it to percentage
                },
              },
            }],
            xAxes: [{
              barPercentage: 0.1,
              gridLines: {
                display: thisElement.chartType !== 'bar',
              },
              ticks: {
                max: this.max,
                beginAtZero: true,
                min: 0,
                autoSkip: false,
                maxTicksLimit: 3,
                fontSize: 10,
                fontColor: '#808080',
                // maxRotation: thisElement.chartType === 'bar' ? 40 : 0,
                // minRotation: thisElement.chartType === 'bar' ? 40 : 0,
                callback(value) {
                  return thisElement.chartType === 'bar' ? value : `${((value / this.max) * 100).toFixed(0)}%`; // convert it to percentage
                },
              },
            }],
          },
          legend: false,
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            enabled: false,
            intersect: false,
            mode: 'nearest',
            custom(tooltipModel) {
              // Tooltip Element
              let tooltipEl = document.getElementById('chartjs-tooltip-interactive');
              const tooltipContainer = document.getElementById('tooltipDisplayInteractive');
              // Create element on first render
              if (!tooltipEl) {
                tooltipEl = document.createElement('div');
                tooltipEl.id = 'chartjs-tooltip-interactive';
                tooltipEl.innerHTML = '<div></div>';
                tooltipContainer.appendChild(tooltipEl);
              }
              // Hide if no tooltip
              if (tooltipModel.opacity === 0) {
                tooltipEl.style.opacity = 0;
                return;
              }
              // Set caret Position
              tooltipEl.classList.remove('above', 'below', 'no-transform');
              if (tooltipModel.yAlign) {
                tooltipEl.classList.add(tooltipModel.yAlign);
              } else {
                tooltipEl.classList.add('no-transform');
              }
              function getBody(bodyItem) {
                return bodyItem.lines;
              }
              // Set Text
              if (tooltipModel.body) {
                const titleLines = tooltipModel.title || [];
                const bodyLines = tooltipModel.body.map(getBody);
                let innerHtml = '';
                let thisTitle;
                let enterprise;
                let thisTotalNumber;
                let thisDelivered;
                let thisRejected;
                let thisProgressNumber;
                let bodyElement;
                bodyLines.forEach(() => {
                  // eslint-disable-next-line prefer-destructuring
                  thisTitle = titleLines[0];
                  enterprise = thisElement.chartData[0][thisTitle];
                  thisTotalNumber = enterprise.progress.total;
                  thisDelivered = enterprise.progress.delivered;
                  thisRejected = enterprise.progress.rejected;
                  thisProgressNumber = thisDelivered + thisRejected;
                  bodyElement = `
                  <p class="tooltipBodyTextDesign">${thisProgressNumber}</p>`;
                  innerHtml += bodyElement;
                });
                titleLines.forEach((title) => {
                  innerHtml += `<h4 class="tooltipTitleTextDesign"><span class="packageTitle">Ordenes</span> ${title}</h4>`;
                });
                const progressStyle = `
                <div class="enterpriseProgressBar">
                  <p class="enterprisePorcentage">${((thisProgressNumber / thisTotalNumber) * 100).toFixed(1)}</p>
                  <div class="enterpriseActualProgress" style="width: ${((thisProgressNumber / thisTotalNumber) * 100).toFixed(1)}%">
                  </div>
                </div>
                <p class="simpleText">Entregados: ${thisDelivered}</p><p class="simpleText">No entregados: ${thisRejected}</p>`;
                innerHtml += progressStyle;
                const tableRoot = tooltipEl.querySelector('div');
                tableRoot.innerHTML = innerHtml;
              }
              // Display, position, and set styles for font
              tooltipEl.style.opacity = 1;
              tooltipEl.style.left = `${tooltipModel.caretX - 20}px`;
              tooltipEl.style.top = `${tooltipModel.caretY - 135}px`;
              tooltipEl.style.fontSize = `${tooltipModel.bodyFontSize}px`;
            },
          },
          onClick(evt, elements) {
            let datasetIndex;
            let dataset;
            if (elements.length) {
              backgroundColors = colorGrey;
              // Find selected data-label //
              const activePoints = this.getElementsAtEvent(evt);
              // eslint-disable-next-line
              const chartDataInfo = activePoints[0]._chart.config.data;
              // eslint-disable-next-line
              const idx = activePoints[0]._index;
              const labelInfo = chartDataInfo.labels[idx];
              const showInfo = thisElement.chartData[0][labelInfo].enterprise;
              // Sending Data to parent
              thisElement.$emit('sendDataToParent', showInfo);
              // Check label index to change colors
              // eslint-disable-next-line
              const index = elements[0]._index;
              // eslint-disable-next-line
              datasetIndex = elements[0]._datasetIndex;
              // Reset old state
              dataset = this.data.datasets[datasetIndex];
              dataset.backgroundColor = backgroundColors.slice();
              dataset.hoverBackgroundColor = hoverBackgrounds.slice();
              dataset.backgroundColor[index] = '#AAD500'; // click color
              dataset.hoverBackgroundColor[index] = '#AAD500';
            } else {
              backgroundColors = colorGreen;
              thisElement.$emit('sendDataToParent', '');
              // remove hover styles
              for (datasetIndex = 0; datasetIndex < this.data.datasets.length; datasetIndex += 1) {
                dataset = this.data.datasets[datasetIndex];
                dataset.backgroundColor = backgroundColors.slice();
                dataset.hoverBackgroundColor = hoverBackgrounds.slice();
              }
            }
            this.update();
          },
        },
      });
    },
  },
  mounted() {
    // this.checkChartType();
    this.init();
    // this.updateChart();
  },
  watch: {
    chartType() {
      // this.checkChartType();
      this.myChart.destroy();
      this.init();
    },
    chartData() {
      this.updateChart();
      this.init();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/var";

  .tooltipDisplayInteractive {
    position: relative;
  }
  .roundedBorder {
    width: 100%;
    box-sizing: border-box;
    padding: 30px 10px 10px 10px;
    border: 1px solid $fb-grey-light-84;
    border-radius: 3px;
    background: white;
    display: inline-block;
  }
  .topTitle {
    text-transform: uppercase;
    font-size: 16px;
    text-align: left;
    margin: 0 0 5px;
  }
  .textContainer{
    width: 1em;
    position: absolute
  }
  .verticalText {
    writing-mode: tb-rl;
    transform: rotate(-180deg);
    margin: 0;
    color: #AAD500;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 900;
    &:after {
      content: 'Progreso';
    }
  }
  .horizontalText {
    margin: 0;
    color: #AAD500;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 900;
    &:after {
      content: 'Empresa';
    }
  }
  .chartContainerVertical {
    display: inline-block;
    width: 99%;
  }
  .chartContainerHorizontal {
    display: inline-block;
    width: 96%;
  }
  .relative {
    position: relative;
  }
  .canvas {
    position: absolute;
    width: 100%;
  }
  .mobileChartStyle {
    background: $fb-grey-light-97;
    padding-top: 1em;
  }
  @media only screen and (max-width: 768px) {
    .topTitle {
      margin: 0 0 1em 30px;
    }
  }
  @media only screen and (max-width: 425px) {
    .topTitle {
      font-size: 12px;
    }
  }
</style>
<style lang="scss">
  @import "../../assets/scss/var";
  #chartjs-tooltip-interactive {
    background: white;
    border: 1px solid $fb-grey-light-84;
    border-radius: 3px;
    position: absolute;
    padding: 10px;
    z-index: 2;
    &::after {
      content: '';
      border-left: 12px solid transparent;
      border-right: 12px solid transparent;
      border-top: 12px solid white;
      position: absolute;
      bottom: -12px;
      left: 7px;
    }
    &::before {
      content: '';
      border-left: 13px solid transparent;
      border-right: 13px solid transparent;
      border-top: 13px solid $fb-grey-light-84;
      position: absolute;
      bottom: -13px;
      left: 6px;
    }
    .tooltipBodyTextDesign {
      font-size: 28px;
      font-weight: 900;
      margin: 0;
      color: $fb-green;
      text-align: center;
    }
    .tooltipTitleTextDesign {
      text-transform: uppercase;
      font-size: 10px;
      color: $fb-grey-light-30;
      font-weight: 900;
      margin: 0;
      text-align: center;
    }
    .packageTitle {
      display: block;
      font-weight: 400;
      letter-spacing: 1px;
    }
  }
  .simpleText {
    font-size: 0.8em;
    font-weight: 300;
    margin: 2px 0;
    text-transform: uppercase;
    color: $fb-grey;
  }
  .percentageContainer {
    margin: 0;
    text-align: right;
    z-index: 5000000;
  }
  .enterprisePorcentage {
    font-weight: 900;
    color: white;
    margin: 0;
    font-size: 0.9em;
    z-index: 3;
    text-shadow: 1px 1px 1px $fb-grey-light-30;
  }
  .enterpriseProgressBar {
    height: 1.2em;
    background: $fb-grey-light-84;
    position: relative;
    z-index: 1;
    box-sizing: border-box;
    overflow: hidden;
  }
  .enterpriseActualProgress {
    position: absolute;
    left: 0;
    top: 0;
    background: $fb-green;
    height: 100%;
    transition: width 1s ease-in-out;
    z-index: -1;
  }
</style>
